/**
 * Created by Administrator on 2017/3/22.
 */
import { Injectable } from "@angular/core";
import { API } from "../config/api-config";
import { StroageService } from "./stroage";

@Injectable()
export class FileUpload {
  constructor(private stroage: StroageService) {}
  public upload(callback, fileType?): void {
    this.send({
      url: API.uploadImg,
      maxSize: 100,
      multiple: true,
      token: this.stroage.getStroage("token"),
      callback: callback,
      fileType: fileType,
    });
  }
  private send(option) {
    let fd = new FormData(),
      xhr = new XMLHttpRequest(),
      input;
    input = document.createElement("input");
    input.setAttribute("id", "myUploadInput");
    input.setAttribute("type", "file");
    input.setAttribute("name", "file");
    if (option.multiple) {
      input.setAttribute("multiple", true);
    }
    document.body.appendChild(input);
    input.style.display = "none";
    input.click();
    let fileType = [];
    console.log(option);
    if (option.fileType) {
      fileType = option.fileType;
    } else {
      fileType = [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "pdf",
        "jpg",
        "jpeg",
        "png",
        "ppt",
        "pptx",
        "svg",
        "ogg",
        "mp4",
      ];
    }
    input.onchange = function () {
      if (!input.value) {
        return;
      }
      let type = input.value.split(".").pop();
      if (fileType.indexOf(type.toLocaleLowerCase()) == -1) {
        alert("暂不支持该类型的文件，请重新选择!");
        return;
      }
      for (let i = 0, file; (file = input.files[i++]); ) {
        if (option.maxSize && file.size > option.maxSize * 1024 * 1024) {
          alert("请上传小于" + option.maxSize + "M的文件");
          return;
        }
      }
      for (let i = 0, file; (file = input.files[i++]); ) {
        fd.append("file", file);
      }

      xhr.open("post", option.url);
      xhr.onreadystatechange = function () {
        if (xhr.status == 200) {
          if (xhr.readyState == 4) {
            if (option.callback instanceof Function) {
              option.callback(xhr.responseText);
            }
          }
        } else {
          alert("上传失败！");
        }
      };
      xhr.upload.onprogress = function (event) {
        let pre = Math.floor((100 * event.loaded) / event.total);
      };
      xhr.setRequestHeader("token", option.token);
      console.log(fd);
      xhr.send(fd);
    };
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/service/file-upload.ts